<mat-card appearance="outlined" aria-hidden="true" class="skeleton-card flex flex-col h-full">

    <div class="skeleton-ownership flex flex-col gap-1 min-w-0">
        <div class="flex flex-row items-center gap-2 min-w-0">
            <div class="skeleton-line skeleton-line-sm w-2/5"></div>
        </div>

        <div class="flex flex-row items-center justify-between gap-2 min-w-0 pt-1">
            <div class="skeleton-line skeleton-line-md w-1/2"></div>
            <div class="skeleton-badge flex-none"></div>
        </div>

        <div class="skeleton-line skeleton-line-sm w-1/3"></div>
    </div>

    <div class="flex flex-col gap-2 pt-4 pb-2 border-b-xs-subtle">
        <div class="skeleton-line skeleton-line-lg w-2/5"></div>
        <div class="skeleton-line skeleton-line-sm w-1/4"></div>
    </div>

    <div class="flex flex-row py-3 border-b-xs-subtle">
        <div class="skeleton-financial-item flex flex-col gap-2 flex-1">
            <div class="skeleton-line skeleton-line-md w-3/5"></div>
            <div class="skeleton-line skeleton-line-sm w-2/5"></div>
        </div>

        <div class="skeleton-financial-item flex flex-col gap-2 flex-1">
            <div class="skeleton-line skeleton-line-md w-3/5"></div>
            <div class="skeleton-line skeleton-line-sm w-2/5"></div>
        </div>

        <div class="skeleton-financial-item flex flex-col gap-2 flex-1">
            <div class="skeleton-line skeleton-line-md w-3/5"></div>
            <div class="skeleton-line skeleton-line-sm w-2/5"></div>
        </div>
    </div>

    <div class="flex flex-row items-center justify-between gap-4 mt-auto pt-4">
        <div class="flex flex-row flex-wrap items-center gap-4">
            <div class="skeleton-badge"></div>
            <div class="skeleton-badge skeleton-badge-wide"></div>
        </div>

        <div class="skeleton-arrow-button flex-none"></div>
    </div>
</mat-card>
